export default {
  dates: {
    default: "DD/MM/YYYY",
    longFormat: "MMMM Do YYYY  [at] h:mma",
    longFormatWithDay: "dddd MMMM Do YYYY  [at] h:mma"
  },
  units: {
    miles: "miles",
    km: "km"
  }
}
